import { Fragment, useEffect } from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { WrappedSelect } from '@quick/components/Forms';

import { useAppTranslation } from '@/app/i18n/client';

import type { IForm } from './types';

interface ISelectorVehicle {
  vehicles: { id: number; name: string }[];
}

export const SelectorVehicle = ({ vehicles }: ISelectorVehicle) => {
  const {
    control,
    formState: { errors },
    setValue,
    getValues,
  } = useFormContext<IForm>();
  const { t } = useAppTranslation(['common', 'demand']);

  useEffect(() => {
    if (vehicles.length === 1) {
      setValue('vehicle_type_id', vehicles[0].id, { shouldDirty: true });
      return;
    }
    // A vehicle kept from a quotation or a previous service type may not be offered anymore.
    const current = getValues('vehicle_type_id');
    if (current && !vehicles.some(({ id }) => id === Number(current)))
      setValue('vehicle_type_id', undefined);
  }, [vehicles, setValue, getValues]);

  return (
    <Controller
      control={control}
      name="vehicle_type_id"
      rules={{
        required: t('common:msg.required_field'),
      }}
      render={({ field }) => {
        // oxlint-disable-next-line react/jsx-no-useless-fragment
        if (vehicles.length === 1) return <Fragment />; // It does not let return null
        return (
          <WrappedSelect
            id="vehicle_type_id"
            requiredMark
            {...field}
            // Keep the select controlled: with an undefined value the browser shows the first
            // option while the form still holds nothing, which reads as "required" on submit.
            value={field.value ?? ''}
            isOnModal
            className="col-start-1"
            label={t('demand:vehicle')}
            error={errors.vehicle_type_id?.message}
          >
            <option hidden value="">
              {t('common:select_option')}
            </option>
            {vehicles?.map(({ id, name }) => (
              <option key={id} value={id}>
                {name}
              </option>
            ))}
          </WrappedSelect>
        );
      }}
    />
  );
};
